import type { Event } from "../../reducers/apiTypes";
import { categoryColor, eventTypeEmoji } from "../../utils/eventDisplay";
import { EventPhotoPlaceholder } from "./EventPhotoPlaceholder";

type Props = {
    event: Event;
    className?: string;
    imgClassName?: string;
    /** Shown only when emoji fallback is not used (legacy text placeholder). */
    label?: string;
    /** Use emoji fallback when no image (default true). */
    showEmoji?: boolean;
    /** Tailwind classes for the emoji when no image is available. */
    emojiClassName?: string;
};

export function EventImage({
    event,
    className = "",
    imgClassName = "",
    label,
    showEmoji = true,
    emojiClassName,
}: Props) {
    const imageUrl = event.image?.trim();
    const color = categoryColor(event.event_type);
    const emoji = showEmoji ? eventTypeEmoji(event.event_type) : undefined;

    if (imageUrl) {
        return (
            <div
                className={`flex items-center justify-center overflow-hidden bg-black ${className}`}
            >
                <img
                    src={imageUrl}
                    alt=""
                    className={`max-h-[100vw] h-full w-full object-contain ${imgClassName}`}
                    loading="lazy"
                />
            </div>
        );
    }

    return (
        <EventPhotoPlaceholder
            color={color}
            emoji={emoji}
            className={className}
            label={label}
            emojiClassName={emojiClassName}
        />
    );
}
